import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { useLanguage } from "@/contexts/LanguageContext";
import { usePageMeta } from "@/hooks/usePageMeta";
import { LegalLinks } from "@/components/LegalLinks";

const notFoundText: Record<string, { title: string; message: string; link: string }> = {
  es: { title: "Página no encontrada", message: "La página que buscas no existe.", link: "Volver al inicio" },
  en: { title: "Page not found", message: "The page you're looking for doesn't exist.", link: "Return to Home" },
  pt: { title: "Página não encontrada", message: "A página que procura não existe.", link: "Voltar ao início" },
  fr: { title: "Page non trouvée", message: "La page que vous recherchez n'existe pas.", link: "Retour à l'accueil" },
};

const NotFound = () => {
  const location = useLocation();
  const { language } = useLanguage();
  const t = notFoundText[language] || notFoundText.es;

  usePageMeta({
    title: `404 - ${t.title} | Gándara International School`,
    description: "",
    noIndex: true,
  });

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center">
        <h1 className="text-4xl font-bold mb-4 text-foreground">404</h1>
        <p className="text-xl text-muted-foreground mb-4">{t.message}</p>
        <Link to={`/${language}`} className="text-primary hover:text-primary/80 underline">
          {t.link}
        </Link>
        <p className="mt-8 text-xs text-muted-foreground">
          <LegalLinks />
        </p>
      </div>
    </div>
  );
};

export default NotFound;
